module.exports = __webpack_public_path__ + "img/icon01.fbdb1233.png";